// src/components/claims/locationLabel.js
// Where a claim / brand-rule item sits: its heading when it has one (H2, H3, FAQ
// question, landing block, slide headline), else the part's name. ⛔ The ordinal is
// not shown: the BE counts only non-empty fields and SUBSECTION counts across the
// article, so a number could point at the wrong place. Unknown part → the code.
export function locationLabel(location, tr) {
  const heading = typeof location?.heading === 'string' ? location.heading.trim() : '';
  if (heading) return heading;
  const part = location?.part;
  if (!part) return '';
  return tr(`claims.part.${part}`, { defaultValue: part });
}
